
import { Component, Mixins } from 'vue-property-decorator';
import EditableItem from '~/components/RemoteFeatureFlags/Flags/EditableItem.vue';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        EditableItem
    }
})
export default class RemoteFeatureFlagsCreator extends Mixins(DarkThemeInfoMixin) {
    valid = false;
    flagName = '';
    description = '';
    expirationDate = this.aYearFromNow;
    menu = false;

    async create() {
        await RemoteFeatureFlagsModule.createFlag({
            name: this.flagName,
            description: this.description,
            expire_at: this.expirationDate
        });
        (this.$refs.editableItem as any)?.$refs?.form?.resetValidation();
        this.resetFields();
    }

    get aYearFromNow() {
        const aYearFromNow = new Date();
        aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
        return aYearFromNow.toISOString().substr(0, 10);
    }

    dateValidator(value: number) {
        if (!value) {
            return 'Expiration date is required';
        }
        if (new Date(value) < new Date()) {
            return 'Expiration date must be in the future';
        }
        return true;
    }

    resetFields() {
        this.flagName = '';
        this.description = '';
        this.expirationDate = this.aYearFromNow;
        this.valid = false;
    }
}
